import { __require as _ } from "./main36.js";
var r, e;
function s() {
  if (e) return r;
  e = 1;
  var a = _(), o = a["__core-js_shared__"];
  return r = o, r;
}
export {
  s as __require
};
